import { IFinanceOperatorsItem, IFinanceOperatorTableData } from 'entities/financeOperations/types';
import { CountriesType } from 'entities/distribution/types';
import { mapTypeOutputToText } from 'widgets/financeOperations/utils';

export const useDefaultFinanceOperationsTableValues = (
  data: IFinanceOperatorsItem[],
  cachedCountries: Record<number, CountriesType>,
): IFinanceOperatorTableData[] => {
  if (!data.length) {
    return [];
  }

  return data.map((financeOperation: IFinanceOperatorsItem) => ({
    id: financeOperation.id,
    service: financeOperation.withdrawal_service.service,
    limit: financeOperation.limit,
    country_name: financeOperation.country_ids.map((id) => cachedCountries[id]?.name).join(', '),
    type: mapTypeOutputToText(financeOperation.type),
    app_type: financeOperation.app_type.toUpperCase(),
  }));
};
